var _ellipse, _path, _circle, _circle2, _circle3, _ellipse2, _path2, _circle4, _circle5, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.5,
    cy: 13,
    rx: 9.5,
    ry: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.49039 21.1263C3.1129 21.2015 2.79558 20.8399 2.9192 20.4754L4.59142 15.5447C4.71504 15.1802 5.1869 15.0862 5.44076 15.3755L8.87473 19.289C9.12859 19.5784 8.97406 20.034 8.59658 20.1092L3.49039 21.1263Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 13.5,
    r: 1.5,
    fill: "#2A2D34"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 13.5,
    r: 1.5,
    fill: "#2A2D34"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 13.5,
    r: 1.5,
    fill: "#2A2D34"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.5,
    cy: 8,
    rx: 9.5,
    ry: 8,
    transform: "matrix(-1 0 0 1 26 0)",
    fill: "#2A2D34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5096 16.1263C25.8871 16.2015 26.2044 15.8399 26.0808 15.4754L24.4086 10.5447C24.285 10.1802 23.8131 10.0862 23.5592 10.3755L20.1253 14.289C19.8714 14.5784 20.0259 15.034 20.4034 15.1092L25.5096 16.1263Z",
    fill: "#2A2D34"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 8.5,
    r: 1.5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 8.5,
    r: 1.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 8.5,
    r: 1.5,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.6eed502e72183ea5e138293e6d52f7ed.svg";
export { ForwardRef as ReactComponent };